/**
 * UAVTradeZone Modification Record
 *
 * Change ID:    SPLIT_USER_PROFILE_ABOUT
 * Date:         2025-12-29
 * Modified By:  Cursor
 *
 * Description:
 * Extracted About Me section from UserProfileForm.tsx.
 *
 * Related Screens / Modules:
 * - client/src/components/setup/user-profile/components/AboutMe.tsx
 */
import React from "react";
import { Form, Card } from "react-bootstrap";

interface AboutMeProps {
  formik: any;
}

export const AboutMe: React.FC<AboutMeProps> = ({ formik }) => {
  return (
    <div className="mt-3">
      {/* Spacer to align with PersonalInformation's profile picture section */}
      <div style={{ visibility: "hidden" }} aria-hidden="true">
        <div className="field-name mb-2">Spacer</div>
        <div className="upload-logo-container" style={{ minHeight: "100px" }}></div>
      </div>

      <Card.Title className="company-profile-title mt-4 mb-3">About me</Card.Title>

      <Form.Control
        as="textarea"
        rows={5}
        className="field-input"
        placeholder="Tell a bit about yourself, your role and experience"
        maxLength={300}
        {...formik.getFieldProps("bio")}
        isInvalid={!!(formik.touched.bio && formik.errors.bio)}
      />
      <div className="text-end text-muted mt-2 u-P3-14">
        {formik.values.bio?.length || 0}/300 characters max.
      </div>
    </div>
  );
};
